import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBestTimetoPost = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 53.32969 53.31969",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "bestTimetoPost" }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.773,32.79864A24.6091,24.6091,0,1,1,23.105,50.209",
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "27.445 4.177 27.445 25.955 38.494 37.106",
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 2.81007,
			y1: 25.95524,
			x2: 9.24156,
			y2: 25.95524,
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 27.44488,
			y1: 50.59005,
			x2: 27.44488,
			y2: 44.15857,
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 45.6482,
			y1: 25.95524,
			x2: 52.07969,
			y2: 25.95524,
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 10.56335,
			y1: 8.15366,
			x2: 13.18029,
			y2: 11.19388,
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 44.54691,
			y1: 8.22409,
			x2: 41.9906,
			y2: 11.19388,
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 45.0014,
			y1: 43.23361,
			x2: 42.44508,
			y2: 40.26382,
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("polygon", {
			points: "11.637 48.414 18.069 51.999 16.83 44.618 22.023 39.662 14.747 38.739 11.637 32.28 8.526 38.739 1.25 39.662 6.443 44.618 5.204 51.999 11.637 48.414",
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		})
	] })]
});
export default SvgBestTimetoPost;
